import script from "./index.vue?vue&type=script&setup=true&name=MaterialFileManager&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=MaterialFileManager&lang=js"

import "./index.vue?vue&type=style&index=0&id=41f89518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f89518"]])

export default __exports__